<template>
  <div
    class="__field"
    :class="fixWidth ? '__full-width' : type === 'block' ? '__block' : ''"
  >
    <div class="__label" :class="required ? '__required' : ''">
      <slot name="label"></slot>
    </div>
    <slot name="input"></slot>
  </div>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    fixWidth: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "inline",
    },
  },
};
</script>

<style lang="scss" scoped>
.__field {
  width: 100%;
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 24px;

  &.__block {
    display: block !important;

    .__label {
      text-align: left;
    }
  }

  &.__fix-width {
    flex: 0 0 auto;
  }

  &.__full-width {
    flex: 1 0 100% !important;
  }

  place-content: center;
  place-items: start;
  .__label {
    width: 100%;
    margin: 0;
    text-align: right;
    padding: 12px 0;

    &.__required {
      &:after {
        content: " *";
        color: red;
      }
    }
  }
}
</style>
